import { OptimizationsService } from '@/client'
import { useFetch } from '@/composables/useFetch'

export async function _getOptimizations(
  args: Parameters<
    typeof OptimizationsService.getOptimizationsApiV1ManagementOptimizationsGet
  >[0] // Correctly type the argument
) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.getOptimizationsApiV1ManagementOptimizationsGet(
        args
      ),
    null,
    { sendToast: false }
  )

  await fetchData()

  return { data: data.value, error: error.value, loading: loading.value }
}

export async function _getOptimization(id: string) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.getSingleOptimizationApiV1ManagementOptimizationsOptimizationIdGet(
        {
          optimizationId: id,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}

export async function _countOptimizations(
  args: Parameters<
    typeof OptimizationsService.countOptimizationsApiV1ManagementOptimizationsCountGet
  >[0] // Correctly type the argument
) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.countOptimizationsApiV1ManagementOptimizationsCountGet(
        args
      ),
    null,
    { sendToast: false }
  )

  await fetchData()

  return { data: data.value, error: error.value, loading: loading.value }
}

export async function _deleteOptimization(id: string) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.deleteOptimizationApiV1ManagementOptimizationsOptimizationIdDelete(
        {
          optimizationId: id,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}

export async function _hideOptimization(id: string) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.hideOptimizationApiV1ManagementOptimizationsOptimizationIdHidePost(
        {
          optimizationId: id,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}

export async function _unhideOptimization(id: string) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.unhideOptimizationApiV1ManagementOptimizationsOptimizationIdUnhidePost(
        {
          optimizationId: id,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}

export async function _executeOptimization(id: string) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.executeApiV1ManagementOptimizationsOptimizationIdExecutePost(
        {
          optimizationId: id
        }
      ),
    null,
    { sendToast: false }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}

export async function _getOptimizationsSavings(
  args: Parameters<
    typeof OptimizationsService.getOptimizationsSavingsApiV1ManagementOptimizationsSavingsGet
  >[0] // Correctly type the argument
) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.getOptimizationsSavingsApiV1ManagementOptimizationsSavingsGet(
        args
      ),
    null,
    { sendToast: false }
  )

  await fetchData()

  return { data: data.value, error: error.value, loading: loading.value }
}

export async function _getOptimizationSavings(id: string) {
  const { data, error, fetchData, loading } = useFetch(
    () =>
      OptimizationsService.getOptimizationSavingsApiV1ManagementOptimizationsOptimizationIdSavingsGet(
        {
          optimizationId: id,
        }
      ),
    null,
    { sendToast: true }
  )
  return fetchData().then(() => {
    return { data: data.value, error: error.value, loading: loading.value }
  })
}
